export default {
  api: 'https://api.illustrationx.com/',
  host: 'https://www.illustrationx.com/',
  imagebase: 'https://media.illustrationx.com/'
}